import * as momentImported from 'moment';

const moment = momentImported;

export const isSameDay = (start: string, end: string): boolean => {
  return moment(start).isSame(end, 'day');
};
